import React from "react";
import "./Common_Headings.css";

function Common_Headings({ title, onSeeAll }) {
  return (
    <div className="d-flex justify-content-between  align-items-center mb-3">
      <h5 className="Heading">{title}</h5>

      {onSeeAll && (
        <span
          className="see-text"
          onClick={onSeeAll}
          style={{ cursor: "pointer" }}
        >
          see all
        </span>
      )}
    </div>
  );
}

export default Common_Headings;
